(ns dre.pages.my-searches.views
  (:require
   [dre.app.router :as-alias router]
   [dre.utils.bem :as bem]
   [dre.components.breadcrumb :as breadcrumb]
   [dre.components.tabs :refer [tabs]]
   [dre.i18n.utils :refer [tr-later]]
   [dre.pages.my-searches.events :as-alias events]
   [re-frame.core :as rf]))

(def ^:private component-name :my-searches)

(defn- header
  []
  [:div
   {:class (bem/be component-name :header)}
   [breadcrumb/breadcrumb @(rf/subscribe [::breadcrumb/items])]])

(def ^:private tab-items
  [{:id :signals
    :label (tr-later "Saved Searches")}
   {:id :search-history
    :label (tr-later "Search History")}
   {:id :tags
    :label (tr-later "Tags")}])

(defn- content
  []
  [:div
   {:class (bem/be component-name :content)}
   [tabs {:items tab-items
          :on-click #(rf/dispatch [::router/redirect-to-handler (:id %)])
          :default-active-id @(rf/subscribe [::events/current-page])}]])

(defn view
  []
  [:div
   {:class component-name}
   [header]
   [content]])
